var populateRoute = function (route, values) {
    if (!values) {
        return route;
    }
    if (Array.isArray(values)) {
        values.forEach(function (value) {
            route = route.replace(/(:.*?)(?=\/|$)/, value);
        });
        return route;
    }
    for (var key in values) {
        if (!values.hasOwnProperty(key)) {
            continue;
        }
        var regex = new RegExp("(:".concat(key, ".*?)(?=\\/|$)"));
        route = route.replace(regex, values[key]);
    }
    return route;
};
export var getRoute = function (routes, name, values) {
    var route = routes.find(function (route) { return route.name === name; });
    if (!route) {
        throw "Route ".concat(name, " was not found!");
    }
    return populateRoute(route.path, values);
};
